<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.referralAdd}}</h3>
</div>
<div class="modal-body dx-form">
    <form #kvForm="ngForm" name="kvForm" class="form-signin" style="max-width:400px">
        <div class="row">
            <div class="col-md-12">
                <label for="referTo">{{LOCALIZATION.referTo}}</label>
			    <input type="text" [(ngModel)]='referTo' id="referTo" name="referTo" class="form-control" placeholder="name@email.com" required autofocus>				                
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <label for="dueDate">{{LOCALIZATION.dueDate}}</label>
                <input type="date" [(ngModel)]='dueDate' id="dueDate" name="dueDate" class="form-control" required>
            </div>
        </div> 
        <div class="row">
            <div class="col-md-12">
                <label for="reason">{{LOCALIZATION.reason}}</label>
                <input type="text" [(ngModel)]='reason' id="reason" name="reason" class="form-control">
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.cancel}}</button>
    <button class="btn btn-primary" type="button" (click)="referTask()" [disabled]="!kvForm.valid || inprogress">
    	<i class="fas fa-spinner fa-spin fa-fw" [hidden]="!inprogress"></i>
    	{{LOCALIZATION.refer}}
    </button>
</div>